// extracted by mini-css-extract-plugin
export default {"home":"home__uRcqa","articles":"articles__I4x5h","spacer":"spacer__lFOci","leftSidebar":"leftSidebar__iLXfa","updown":"updown__t0Z5u"};